export default function guideCalendar() {
    const calNav = $('#calNav');
    if (calNav.length > 0) {
        calNav.on('click', '.navMonth', function animateToClickedMonth(e) {
            e.preventDefault();
            const id = `#${$(this).attr('data-month')}`;
            const theOffset = $(id).offset().top - 38;
            $('html,body').animate({ scrollTop: theOffset }, 'slow');
        });

        const { top } = calNav.offset();
        $(window).scroll(() => {
            const pos = $(window).scrollTop();
            if (pos >= top) {
                calNav.css({ position: 'fixed' });
            } else {
                calNav.css({ position: 'absolute' });
            }
        });
    }
}
